// @ts-ignore
// eslint-disable-next-line func-names
Element.prototype.myParentElement = function () {
    return this.parentElement || document.body;
};
